(() => {
  const markJudgeReviewSections = () => {
    let marked = 0;
    document.querySelectorAll('.jdgm-widget.jdgm-review-widget').forEach((widget) => {
      const section = widget.closest('.section-apps');
      if (section && !section.classList.contains('rx-judge-reviews-section')) {
        section.classList.add('rx-judge-reviews-section');
        marked += 1;
      }
    });
    return marked;
  };

  const watchJudgeReviewSections = () => {
    markJudgeReviewSections();
    if (document.documentElement.dataset.rxJudgeObserver === 'ready') return;

    document.documentElement.dataset.rxJudgeObserver = 'ready';
    const observer = new MutationObserver(() => {
      if (markJudgeReviewSections() > 0) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  const initProductUi = () => {
  const mainSection = document.querySelector('.section-product-info');
  if (!mainSection) return;

  mainSection.classList.add('rinoxar-product-ui');
  document.documentElement.classList.add('rx-product-page');

  const productRoot =
    mainSection.querySelector('.main-product > [id^="x-product-template-"]') ||
    mainSection.querySelector('[id^="x-product-template-"][id*="-template--"]');
  const columns = productRoot?.querySelector(':scope > div');
  const info = mainSection.querySelector('[id^="ProductInfo-"]');
  const infoBlocks = info?.querySelector(':scope > .flex');

  if (!productRoot || !columns || !info || !infoBlocks) {
    mainSection.dataset.rxProductUi = 'ready';
    return;
  }

  const icon = (name) => {
    const paths = {
      stock: '<circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16 9"/>',
      truck: '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>'
    };
    return `<svg viewBox="0 0 24 24" aria-hidden="true">${paths[name]}</svg>`;
  };

  const titleBlock = infoBlocks.querySelector('.x-block-product-title');
  const title = titleBlock?.querySelector('h1,h2');
  if (titleBlock && title && !titleBlock.querySelector('.rx-product-eyebrow')) {
    const value = title.textContent.toLocaleLowerCase();
    let category = 'UTENSILI DA GIARDINO';
    if (value.includes('motosega')) category = 'MOTOSEGHE';
    else if (value.includes('tagliaerba')) category = 'TAGLIAERBA';
    else if (value.includes('soffiatore')) category = 'SOFFIATORI';
    else if (value.includes('decespugliatore')) category = 'DECESPUGLIATORI';
    else if (value.includes('siepe')) category = 'TAGLIASIEPI';

    const eyebrow = document.createElement('div');
    eyebrow.className = 'rx-product-eyebrow';
    eyebrow.textContent = category;
    titleBlock.insertBefore(eyebrow, title);
  }

  const judgePreviewBadge = infoBlocks.querySelector('.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge');
  const judgeBadgeBlock = judgePreviewBadge?.closest('.x-block-app');
  if (judgeBadgeBlock) {
    judgeBadgeBlock.classList.add('rx-judge-rating');

    const averageRating = Number(judgePreviewBadge.dataset.averageRating);
    const reviewCount = Number(judgePreviewBadge.dataset.numberOfReviews);
    const judgeStars = judgePreviewBadge.querySelector('.jdgm-prev-badge__stars');
    const judgeCount = judgePreviewBadge.querySelector('.jdgm-prev-badge__text');

    if (judgeStars && Number.isFinite(averageRating) && !judgePreviewBadge.querySelector('.rx-judge-score')) {
      const score = document.createElement('span');
      score.className = 'rx-judge-score';
      score.textContent = averageRating.toFixed(1);
      score.setAttribute('aria-label', `Valutazione media ${averageRating.toFixed(1)} su 5`);
      judgeStars.insertAdjacentElement('afterend', score);
    }

    if (judgeCount && Number.isFinite(reviewCount) && !judgeCount.dataset.rxFormatted) {
      judgeCount.textContent = `(${reviewCount} ${reviewCount === 1 ? 'recensione' : 'recensioni'})`;
      judgeCount.dataset.rxFormatted = 'true';
    }
  }

  if (false && titleBlock && !infoBlocks.querySelector('.rx-product-proof')) {
    const proof = document.createElement('div');
    proof.className = 'rx-product-proof';
    proof.setAttribute('aria-label', 'Sicurezza e qualità verificate');
    proof.innerHTML = `
      <span class="rx-product-proof-stars" aria-hidden="true">★★★★★</span>
    `;
    titleBlock.insertAdjacentElement('afterend', proof);
  }

  const priceContainer = infoBlocks.querySelector('[id^="price-"]');
  const targetPrice = Number(priceContainer?.querySelector('.target-price')?.textContent.trim());
  const comparePrice = Number(priceContainer?.querySelector('.target-compare-at-price')?.textContent.trim());
  priceContainer
    ?.querySelector('.price-sale')
    ?.parentElement?.classList.add('rx-price-row');
  if (
    priceContainer &&
    Number.isFinite(targetPrice) &&
    Number.isFinite(comparePrice) &&
    comparePrice > targetPrice &&
    !priceContainer.querySelector('.rx-discount-badge')
  ) {
    const discount = Math.round((1 - targetPrice / comparePrice) * 100);
    const badge = document.createElement('span');
    badge.className = 'rx-discount-badge';
    badge.textContent = `-${discount}%`;
    badge.setAttribute('aria-label', `Sconto del ${discount}%`);
    priceContainer.appendChild(badge);
  }

  const mediaBadgeHost = mainSection.querySelector(
    '[id^="x-product-template-"] .x-badges-container .top-left-container'
  );
  if (mediaBadgeHost) {
    mediaBadgeHost
      .querySelectorAll(':scope > .x-badge-container')
      .forEach((item) => item.classList.add('rx-native-media-badge-hidden'));

    let mediaBadges = mediaBadgeHost.querySelector('.rx-media-badges');
    if (!mediaBadges) {
      mediaBadges = document.createElement('div');
      mediaBadges.className = 'rx-media-badges';
      mediaBadges.innerHTML = `
        <span class="rx-media-badge rx-media-badge-discount"></span>
        <span class="rx-media-badge rx-media-badge-new">NUOVO</span>
      `;
      mediaBadgeHost.appendChild(mediaBadges);
    }
    const mediaDiscountBadge = mediaBadges.querySelector('.rx-media-badge-discount');
    const hasDiscount =
      Number.isFinite(targetPrice) &&
      Number.isFinite(comparePrice) &&
      comparePrice > targetPrice;
    mediaDiscountBadge.classList.toggle('is-hidden', !hasDiscount);
    if (hasDiscount) {
      const mediaDiscount = Math.round((1 - targetPrice / comparePrice) * 100);
      mediaDiscountBadge.textContent = `-${mediaDiscount}%`;
      mediaDiscountBadge.setAttribute('aria-label', `Sconto del ${mediaDiscount}%`);
    }
  }

  const buyBlock = infoBlocks.querySelector('.x-block-buy-buttons');
  const addButton = buyBlock?.querySelector('button[type="submit"]');
  const existingAvailability = infoBlocks.querySelector('.rx-availability-card');
  const deliveryBlock =
    infoBlocks.querySelector('.x-block-estimate-delivery') ||
    existingAvailability?.querySelector('.x-block-estimate-delivery');
  const customStats = infoBlocks.querySelector('.custom-html');

  if (deliveryBlock) {
    deliveryBlock.classList.remove('rx-availability-delivery');
    infoBlocks.insertBefore(deliveryBlock, customStats || buyBlock);
  }
  existingAvailability?.remove();

  const statsBlock = infoBlocks.querySelector('.custom-html');
  if (statsBlock && !statsBlock.querySelector('.rx-compact-stats')) {
    const statItems = [];
    const originalItems = Array.from(statsBlock.querySelectorAll(':scope > div > div'));

    originalItems.forEach((item) => {
      const label = item.querySelector('strong')?.textContent.replace(/\s+/g, ' ').trim();
      const value = Array.from(item.querySelectorAll('p'))
        .find((paragraph) => !paragraph.querySelector('strong') && paragraph.textContent.trim())
        ?.textContent.replace(/\s+/g, ' ').trim();
      const iconNode = item.querySelector('img, svg')?.cloneNode(true);
      if (label && value) statItems.push({ label, value, iconNode });
    });

    const specificationRows = Array.from(
      infoBlocks.querySelectorAll('.table_of_information .rinoxar-specs-enhanced > li')
    );
    [
      { match: 'potenza motore', shortLabel: 'Potenza' },
      { match: 'peso articolo', shortLabel: 'Peso' }
    ].forEach(({ match, shortLabel }) => {
      const row = specificationRows.find((item) =>
        item.querySelector('.rinoxar-spec-label')?.textContent.toLocaleLowerCase().includes(match)
      );
      const value = row?.querySelector('.rinoxar-spec-value')?.textContent.replace(/\s+/g, ' ').trim();
      const iconNode = row?.querySelector('.rinoxar-spec-icon svg')?.cloneNode(true);
      if (value) statItems.push({ label: shortLabel, value, iconNode });
    });

    if (statItems.length >= 2) {
      const compactStats = document.createElement('div');
      compactStats.className = 'rx-compact-stats';

      statItems.slice(0, 4).forEach(({ label, value, iconNode }) => {
        const item = document.createElement('div');
        item.className = 'rx-compact-stat';

        const iconWrap = document.createElement('span');
        iconWrap.className = 'rx-compact-stat-icon';
        iconWrap.setAttribute('aria-hidden', 'true');
        if (iconNode) iconWrap.appendChild(iconNode);

        const copy = document.createElement('span');
        copy.className = 'rx-compact-stat-copy';
        copy.innerHTML = `
          <strong class="rx-compact-stat-value"></strong>
          <span class="rx-compact-stat-label"></span>
        `;
        copy.querySelector('.rx-compact-stat-value').textContent = value;
        copy.querySelector('.rx-compact-stat-label').textContent = label;

        item.append(iconWrap, copy);
        compactStats.appendChild(item);
      });

      statsBlock.classList.add('rx-compact-stats-block');
      statsBlock.replaceChildren(compactStats);
    }
  }

  const thumbnailGalleries = Array.from(
    mainSection.querySelectorAll('[id^="x-product-thumbnail-"] > div')
  );
  thumbnailGalleries.forEach((thumbnailGallery) => {
    if (thumbnailGallery.dataset.rxMoreMediaReady === 'true') return;

    const thumbnails = Array.from(thumbnailGallery.querySelectorAll(':scope > .media-thumbnail'));
    if (thumbnails.length <= 6) return;

    const moreThumbnail = thumbnails[5];
    const moreButton = moreThumbnail.querySelector('button') || moreThumbnail;
    moreThumbnail.classList.add('rx-more-media');
    moreThumbnail.dataset.moreCount = `+${thumbnails.length - 5}`;
    moreButton.setAttribute('aria-expanded', 'false');
    moreButton.setAttribute(
      'aria-label',
      `Mostra tutte le ${thumbnails.length} immagini del prodotto`
    );

    moreButton.addEventListener(
      'click',
      (event) => {
        if (thumbnailGallery.classList.contains('rx-media-expanded')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        thumbnailGallery.classList.add('rx-media-expanded');
        moreThumbnail.classList.remove('rx-more-media');
        moreThumbnail.removeAttribute('data-more-count');
        moreButton.setAttribute('aria-expanded', 'true');
        moreButton.setAttribute('aria-label', 'Immagine del prodotto');
      },
      { capture: true }
    );

    thumbnailGallery.dataset.rxMoreMediaReady = 'true';
  });

  const productGalleries = Array.from(
    mainSection.querySelectorAll('[id^="x-product-template-"].swiper-product')
  );
  productGalleries.forEach((gallery) => {
    if (gallery.dataset.rxMobileSwipeReady === 'true') return;

    const gestureSurface = gallery.querySelector('.splide__track') || gallery;
    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
    const isInteractiveMedia = (target) =>
      target instanceof Element &&
      Boolean(
        target.closest(
          'video, iframe, input, select, textarea, .shopify-model-viewer-ui, [data-media-type="model"]'
        )
      );

    let startX = 0;
    let startY = 0;
    let startIndex = null;
    let tracking = false;
    let suppressClick = false;

    const goToAdjacentMedia = (direction) => {
      if (gallery.splide && typeof gallery.splide.go === 'function') {
        gallery.splide.go(direction > 0 ? '>' : '<');
        return;
      }

      const thumbnails = Array.from(
        mainSection.querySelectorAll('[id^="x-product-thumbnail-"] .media-thumbnail')
      );
      if (!thumbnails.length) return;

      let activeIndex = thumbnails.findIndex(
        (thumbnail) => !thumbnail.classList.contains('opacity-30')
      );
      if (activeIndex < 0) activeIndex = 0;
      const nextIndex = Math.max(
        0,
        Math.min(thumbnails.length - 1, activeIndex + direction)
      );
      if (nextIndex === activeIndex) return;

      const trigger = thumbnails[nextIndex].querySelector('button') || thumbnails[nextIndex];
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    };

    gestureSurface.addEventListener(
      'touchstart',
      (event) => {
        if (!isMobile() || event.touches.length !== 1 || isInteractiveMedia(event.target)) {
          tracking = false;
          return;
        }

        const touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        startIndex =
          gallery.splide && Number.isInteger(gallery.splide.index)
            ? gallery.splide.index
            : null;
        tracking = true;
        suppressClick = false;
      },
      { passive: true }
    );

    gestureSurface.addEventListener(
      'touchend',
      (event) => {
        if (!tracking || !isMobile() || !event.changedTouches.length) return;
        tracking = false;

        const touch = event.changedTouches[0];
        const distanceX = touch.clientX - startX;
        const distanceY = touch.clientY - startY;
        if (
          Math.abs(distanceX) < 44 ||
          Math.abs(distanceX) <= Math.abs(distanceY) * 1.2
        ) {
          return;
        }

        suppressClick = true;
        const direction = distanceX < 0 ? 1 : -1;
        window.requestAnimationFrame(() => {
          const splideAlreadyMoved =
            startIndex !== null &&
            gallery.splide &&
            gallery.splide.index !== startIndex;
          if (!splideAlreadyMoved) goToAdjacentMedia(direction);
        });
      },
      { passive: true }
    );

    gestureSurface.addEventListener(
      'touchcancel',
      () => {
        tracking = false;
      },
      { passive: true }
    );

    gestureSurface.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    gallery.querySelectorAll('img').forEach((image) => {
      image.draggable = false;
    });
    gallery.dataset.rxMobileSwipeReady = 'true';
  });

  const moveFeatureIcons = () => {
    const featureIcons = infoBlocks.querySelector('.x-block-feature-icons');
    if (!featureIcons || productRoot.querySelector('.rx-trust-strip')) return;
    const trustStrip = document.createElement('div');
    trustStrip.className = 'rx-trust-strip';
    trustStrip.appendChild(featureIcons);
    productRoot.appendChild(trustStrip);
  };
  moveFeatureIcons();

  markJudgeReviewSections();

  const description = infoBlocks.querySelector('.x-block-description');
  const specifications = infoBlocks.querySelector('.table_of_information');
  const policies = Array.from(infoBlocks.querySelectorAll('[class*="x-block-collapsible-tab"]'));
  const featureList = infoBlocks.querySelector('.x-block-text');
  policies.forEach((policy) => policy.remove());

  if (description && !infoBlocks.querySelector('.rx-product-summary')) {
    const descriptionParagraphNode = Array.from(description.querySelectorAll('p'))
      .find((paragraph) => paragraph.textContent.replace(/\s+/g, ' ').trim().length > 70);
    let descriptionParagraph = descriptionParagraphNode?.textContent.replace(/\s+/g, ' ').trim();
    const headingText = descriptionParagraphNode?.querySelector('strong')?.textContent.replace(/\s+/g, ' ').trim();
    if (descriptionParagraph && headingText && descriptionParagraph.startsWith(headingText)) {
      descriptionParagraph = descriptionParagraph.slice(headingText.length).trim();
    }
    if (descriptionParagraph) {
      const summary = document.createElement('p');
      summary.className = 'rx-product-summary';
      summary.textContent =
        descriptionParagraph.length > 260
          ? `${descriptionParagraph.slice(0, 257).replace(/\s+\S*$/, '')}\u2026`
          : descriptionParagraph;
      const coupon = infoBlocks.querySelector('.x-coupon-code-block');
      (coupon || infoBlocks.querySelector('.x-block-price'))?.insertAdjacentElement('afterend', summary);
    }
  }

  if ((description || specifications) && !productRoot.querySelector('.rx-detail-hub')) {
    const hub = document.createElement('section');
    hub.className = 'rx-detail-hub';
    hub.setAttribute('aria-label', 'Informazioni dettagliate sul prodotto');
    hub.innerHTML = `
      <nav class="rx-detail-tabs" aria-label="Sezioni prodotto">
        <a class="rx-detail-tab" href="#rx-description">Descrizione</a>
        <a class="rx-detail-tab" href="#rx-specifications">Specifiche tecniche</a>
      </nav>
      <div class="rx-detail-grid"></div>
    `;
    const grid = hub.querySelector('.rx-detail-grid');

    if (description) {
      const panel = document.createElement('div');
      panel.className = 'rx-detail-panel';
      panel.id = 'rx-description';
      panel.innerHTML = '<h2 class="rx-detail-panel-title">Descrizione</h2>';
      panel.appendChild(description);
      if (featureList) {
        featureList.classList.add('rx-detail-features');
        panel.appendChild(featureList);
      }
      grid.appendChild(panel);
    }

    if (specifications) {
      const panel = document.createElement('div');
      panel.className = 'rx-detail-panel';
      panel.id = 'rx-specifications';
      panel.innerHTML = '<h2 class="rx-detail-panel-title">Specifiche tecniche</h2>';
      panel.appendChild(specifications);
      grid.appendChild(panel);
    }

    productRoot.appendChild(hub);
  }

  const existingHub = productRoot.querySelector('.rx-detail-hub');
  if (existingHub) {
    const descriptionPanel = existingHub.querySelector('#rx-description');
    const specificationPanel = existingHub.querySelector('#rx-specifications');
    if (description && descriptionPanel && !description.closest('.rx-detail-hub')) {
      descriptionPanel.appendChild(description);
    }
    if (featureList && descriptionPanel && !featureList.closest('.rx-detail-hub')) {
      featureList.classList.add('rx-detail-features');
      descriptionPanel.appendChild(featureList);
    }
    if (specifications && specificationPanel && !specifications.closest('.rx-detail-hub')) {
      specificationPanel.appendChild(specifications);
    }
  }

  const enhanceLowerSections = () => {
    const lowerSections = Array.from(mainSection.parentElement?.querySelectorAll(':scope > .x-section') || []);
    lowerSections.forEach((section) => {
      if (section === mainSection) return;
      const heading = section.querySelector('h1,h2,h3')?.textContent.trim().toLocaleLowerCase() || '';
      if (heading.includes('certificazione')) {
        section.classList.add('rx-certificates');
        const headingNode = section.querySelector('h1,h2,h3');
        const headingWrap = headingNode?.parentElement;
        if (headingWrap && !headingWrap.querySelector('.rx-section-intro')) {
          const intro = document.createElement('p');
          intro.className = 'rx-section-intro';
          intro.textContent =
            'Documentazione CE e rapporti di prova presentati in modo chiaro, per una verifica trasparente di sicurezza e conformit\u00e0.';
          headingWrap.appendChild(intro);
        }
      }
      if (heading.includes('feedback reale')) section.classList.add('rx-feedback');
      if (heading.includes('visti di recente') || heading.includes('prodotti correlati')) section.classList.add('rx-related');
      if (heading === 'our gallery') section.classList.add('rx-hide-section');
    });

    const emptySections = lowerSections.filter((section) => {
      if (section.classList.contains('rx-hide-section')) return false;
      const images = section.querySelectorAll('img,video,iframe').length;
      const text = section.textContent.replace(/\s+/g, ' ').trim();
      return images === 0 && text.length < 10;
    });
    emptySections.forEach((section) => section.classList.add('rx-hide-section'));
  };

  moveFeatureIcons();
  enhanceLowerSections();
  window.requestAnimationFrame(() => {
    mainSection.dataset.rxProductUi = 'ready';
  });
  };

  const scheduleInit = () => {
    watchJudgeReviewSections();
    initProductUi();
    window.setTimeout(markJudgeReviewSections, 2500);
    window.setTimeout(markJudgeReviewSections, 5000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }
  document.addEventListener('shopify:section:load', scheduleInit);
})();
